import axios from "axios";
import { API_URL } from "../../../js/Helper";

export const postAccessRequest = async (data) => {
    const req = await axios.post(`${API_URL}/auth/access-request`, data);
    return req;
}